
    import './styles.scoped.css';
    export default {
  "appbar": "awsui_appbar_hyvsj_acr3f_93",
  "appbar-nav": "awsui_appbar-nav_hyvsj_acr3f_117",
  "breadcrumbs": "awsui_breadcrumbs_hyvsj_acr3f_121",
  "appbar-tools": "awsui_appbar-tools_hyvsj_acr3f_125",
  "background": "awsui_background_hyvsj_acr3f_212",
  "content": "awsui_content_hyvsj_acr3f_236",
  "layout": "awsui_layout_hyvsj_acr3f_300",
  "block-body-scroll": "awsui_block-body-scroll_hyvsj_acr3f_460",
  "container": "awsui_container_hyvsj_acr3f_468",
  "unfocusable": "awsui_unfocusable_hyvsj_acr3f_554",
  "navigation-container": "awsui_navigation-container_hyvsj_acr3f_562",
  "show-navigation": "awsui_show-navigation_hyvsj_acr3f_586",
  "animating": "awsui_animating_hyvsj_acr3f_608",
  "showButtons": "awsui_showButtons_hyvsj_acr3f_1",
  "navigation": "awsui_navigation_hyvsj_acr3f_562",
  "openNavigation": "awsui_openNavigation_hyvsj_acr3f_1",
  "animated-content": "awsui_animated-content_hyvsj_acr3f_668",
  "hide-navigation": "awsui_hide-navigation_hyvsj_acr3f_677",
  "notifications": "awsui_notifications_hyvsj_acr3f_687",
  "split-panel-bottom": "awsui_split-panel-bottom_hyvsj_acr3f_744",
  "openSplitPanelBottom": "awsui_openSplitPanelBottom_hyvsj_acr3f_1",
  "split-panel-side": "awsui_split-panel-side_hyvsj_acr3f_809",
  "openSplitPanelSide": "awsui_openSplitPanelSide_hyvsj_acr3f_1",
  "tools-container": "awsui_tools-container_hyvsj_acr3f_877",
  "tools": "awsui_tools_hyvsj_acr3f_877",
  "openTools": "awsui_openTools_hyvsj_acr3f_1",
  "hide-tools": "awsui_hide-tools_hyvsj_acr3f_970",
  "show-tools": "awsui_show-tools_hyvsj_acr3f_981",
  "trigger": "awsui_trigger_hyvsj_acr3f_1038"
};
  